import Icon from '@components/Icon'
import { currencyFromSymbol } from 'shared/currency-utilities'
import { FormattedNumber } from '@i18n'
import './index.scss'

const ListItem = ({ onClick, ...event }) => {
    const { label, price, rateName, secondaryText, currencySymbol } = event

    const onClickHandler = () => {
        onClick(event)
    }

    return (
        <li className={'search-events-modal__body__list-item'} onClick={onClickHandler}>
            <div className="mr-auto w-100">
                <div className="search-events-modal__body__list-item__row search-events-modal__body__list-item__row--first">
                    <p>{label}</p>
                    <p>
                        {price && (
                            <FormattedNumber
                                value={price}
                                style="currency"
                                currency={currencyFromSymbol(currencySymbol)}
                            />
                        )}
                    </p>
                </div>
                <div className="search-events-modal__body__list-item__row search-events-modal__body__list-item__row--second">
                    <p>
                        {secondaryText.map((text, index) => (
                            <span key={index}>{text}</span>
                        ))}
                    </p>

                    <p className="text-sm-right ml-sm-3">{rateName}</p>
                </div>
            </div>
            <Icon type="next" />
        </li>
    )
}

ListItem.propTypes = {
    label: PropTypes.string,
    price: PropTypes.number,
    rateName: PropTypes.string,
    secondaryText: PropTypes.arrayOf(PropTypes.string),
}

export default ListItem
